import { cssPropertyToDefaultValueMap, REGULAR_STATE } from '../constants';
export function generateSkinDefaults(allSkins) {
    return Object.entries(allSkins).reduce((acc, [skinName, skinParams]) => {
        acc[skinName] = Object.entries(skinParams).reduce((skinDefaults, [paramName, def]) => {
            const { type, defaultValue } = def;
            skinDefaults.types[paramName] = type;
            if (defaultValue) {
                skinDefaults.defaults[paramName] = defaultValue;
            }
            return skinDefaults;
        }, { types: {}, defaults: {} });
        return acc;
    }, {});
}
export function generateDefaultStyleProperties(allSkins, mapToInitial) {
    return Object.entries(allSkins).reduce((acc, [skinName, skinParams]) => {
        acc[skinName] = Object.entries(skinParams).reduce((styleProperties, [paramName, def]) => {
            styleProperties[paramName] = mapToInitial
                ? 'initial'
                : def.defaultValue ?? 'initial';
            return styleProperties;
        }, {});
        return acc;
    }, {});
}
export const withDefaultValues = (params) => {
    return Object.keys(params).reduce((acc, key) => {
        return {
            ...acc,
            [key]: {
                ...params[key],
                defaultValue: params[key].defaultValue || cssPropertyToDefaultValueMap[key],
            },
        };
    }, {});
};
export const extractDefaultValues = (skinDefinition) => {
    const defaults = withDefaultValues(skinDefinition);
    return Object.keys(defaults).reduce((acc, key) => {
        return {
            ...acc,
            [key]: skinDefinition[key].defaultValue || 'initial',
        };
    }, {});
};
export const withParts = (parts, params) => {
    return Object.keys(params).reduce((acc, key) => {
        const newKeys = parts.map(part => `${part}-${key}`);
        return {
            ...acc,
            ...newKeys.reduce((keysAcc, partKey) => ({
                ...keysAcc,
                [partKey]: params[key],
            }), {}),
        };
    }, {});
};
export const withStates = (stateNames, params, defaultState) => {
    return stateNames.reduce((acc, stateName) => {
        // UDP expects that default state
        // will be without part prefix in the property name
        const result = stateName === defaultState ? params : withParts([stateName], params);
        Object.entries(result).forEach(([key, value]) => {
            result[key] = {
                ...value,
                state: stateName,
            };
        });
        return {
            ...acc,
            ...result,
        };
    }, {});
};
export const fontSkinParams = {
    font: {
        type: 'FONT',
        state: REGULAR_STATE.id,
    },
    color: {
        type: 'CSS_COLOR',
        state: REGULAR_STATE.id,
    },
    'letter-spacing': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'line-height': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'text-outline': {
        type: 'CSSString',
        state: REGULAR_STATE.id,
    },
    'text-shadow': {
        type: 'TEXT_SHADOW',
        state: REGULAR_STATE.id,
    },
    'text-transform': {
        type: 'CSSString',
        state: REGULAR_STATE.id,
    },
    'text-highlight': {
        type: 'CSS_COLOR',
        state: REGULAR_STATE.id,
    },
};
export const layoutSkinParams = {
    'padding-bottom': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'padding-top': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'padding-left': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'padding-right': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
};
export const borderSkinParams = {
    'border-left': {
        type: 'BORDER_SIDE',
        state: REGULAR_STATE.id,
    },
    'border-right': {
        type: 'BORDER_SIDE',
        state: REGULAR_STATE.id,
    },
    'border-top': {
        type: 'BORDER_SIDE',
        state: REGULAR_STATE.id,
    },
    'border-bottom': {
        type: 'BORDER_SIDE',
        state: REGULAR_STATE.id,
    },
};
export const cornerSkinParams = {
    'border-top-left-radius': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'border-top-right-radius': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'border-bottom-left-radius': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
    'border-bottom-right-radius': {
        type: 'SIZE',
        state: REGULAR_STATE.id,
    },
};
export const backgroundSkinParams = {
    background: {
        type: 'BACKGROUND_FILL',
        state: REGULAR_STATE.id,
    },
};
export const boxShadowSkinParams = {
    'box-shadow': {
        type: 'BOX_SHADOW',
        state: REGULAR_STATE.id,
    },
};
//# sourceMappingURL=skinParams.js.map